module.exports = __webpack_public_path__ + "static/media/Magby_gaussian2.cbe2299c.png";